
(function() {
  var result = { translations: { "en": { "ui": { "UIAbstractPageSection": { "page": "Page Section" }, "UICarousel": { "current": "Showing item {{currentStepDisplayNumber}} out of {{totalSteps}}", "prev": "Previous", "next": "Next", "tip": "Use arrow keys to see other items" }, "UIColorSwatch": { "label": "Color picker {{value}}", "noColorLabel": "Color picker, no color selected." }, "UIButtonCollapser": { "dropdownLabel": "Actions" }, "UIErrorMessage": { "error": { "title": "All is not lost." }, "notFound": { "title": "All who wander are not lost." }, "badRequest": { "title": "There was a problem loading this page." }, "expired": { "title": "We're sorry." } }, "UIPanelNavigator": { "backButton": "Go to previous screen" }, "UILoadingSpinner": { "busyText": "Loading", "completedText": "Loaded" }, "UISideNav": { "navigationLandmark": "Secondary" }, "UISortTH": { "ascendingSort": "Ascending sort. Press to sort descending.", "descendingSort": "Descending sort. Press to sort ascending.", "pressToSort": "Press to sort." }, "autosizedTextInput": { "charactersRemaining": "{{value}} characters remaining" }, "time": { "today": "Today at {{time}}", "yesterday": "Yesterday at {{time}}", "datetime": "{{date}} at {{time}}" }, "progress": { "percentComplete": "{{percent}} complete" }, "datePicker": { "dateSelected": "{{date}} is selected.", "noDateSelected": "No date selected.", "dateBelowMin": "You must choose a newer date", "dateAboveMax": "You must choose an older date", "invalidDate": "Invalid date", "today": "Today", "clear": "Clear", "placeholder": { "month": "MM", "day": "DD", "year": "YYYY" }, "nextMonth": "Next month", "prevMonth": "Previous month" }, "dateRange": { "startDate": "Start date", "endDate": "End date", "endDateBeforeStartDate": "The end date must come after the start date.", "startDateAfterEndDate": "The start date must come before the end date.", "to": "to" }, "timePicker": { "placeholder": { "hour": "HH", "minute": "MM" } }, "SelectResultList": { "andMore": "\u2026and {{count}} more.", "loadMore": "Load more" } }, "salesUI": { "UIAvatarHoverlay": { "text": "Change photo" }, "UIChangeArrow": { "decrease": "Decrease of ", "increase": "Increase of " }, "UICopyInput": { "label": "Copy", "title": "Copy to clipboard", "tooltipCopied": "Copied" }, "UIConfirm": { "defaultConfirm": "Yes", "defaultReject": "No" }, "UICloseButton": { "label": "Close" }, "UIDateRangePicker": { "rangeType": { "ALL": "All time", "THIS_DAY": "Today", "LAST_DAY": "Yesterday", "THIS_WEEK": "This week", "LAST_WEEK": "Last week", "THIS_MONTH": "This month", "LAST_MONTH": "Last month", "LAST_THIRTY_DAYS": "Last 30 days", "LAST_THREE_MONTHS": "Last 3 months", "THIS_QUARTER": "This quarter", "LAST_QUARTER": "Last quarter", "THIS_YEAR": "This year", "LAST_YEAR": "Last year", "CUSTOM": "Custom time period" } }, "UIDropdownSelect": { "placeholder": "No value selected" }, "UIEditableControls": { "cancel": "Cancel", "save": "Save" }, "UIExpandableText": { "collapseButtonText": "See less", "expandButtonText": "See more" }, "UIFileInput": { "defaultChangeLabel": "Change file", "defaultSelectLabel": "Choose file" }, "UIIconRating": { "ariaValueText": "{{value}} of {{maxValue}}" }, "UILink": { "externalTitle": "Link opens in a new window" }, "UILoading": { "title": "Loading\u2026" }, "UILockBadge": { "title": "This feature is locked" }, "UIPaginator": { "label": "Pagination", "pageNumber": { "currentIndicator": "You are currently on ", "description": "Page " }, "firstPage": { "label": "First", "description": "First page" }, "previousPage": { "label": "Prev", "description": "Previous page" }, "nextPage": { "label": "Next", "description": "Next page" }, "lastPage": { "label": "Last", "description": "Last page" } }, "UIPreviousButton": { "label": "Previous" }, "UINextButton": { "label": "Next" }, "UINumberRating": { "lowRangeLabel": "Strongly disagree", "highRangeLabel": "Strongly agree" }, "UISearchableSelectInput": { "placeholder": "Search" }, "UISearchInput": { "placeholder": "Search", "minimumSearchMessage": { "one": "Type 1 more character", "other": "Type {{count}} more characters" }, "clearButton": "Clear input" }, "UISelect": { "allOptionsSelected": "All options are selected", "createOption": "Create option \u201C{{label}}\u201D", "plusMore": "+ {{count}} more", "andMore": "\u2026and {{count}} more.", "loadMore": "Load more", "noResults": "No results found", "placeholder": "Search", "typeToSearch": "Type to search" }, "UITabs": { "moreDropdownLabel": "More" }, "UITeaseNotification": { "optionsButtonTooltipText": "Show options" }, "UITextToolbarButton": { "remove": "Remove {{name}}", "noop": "You can't {{name}} the current selection" }, "UITimePicker": { "placeholder": "Select a time" }, "UIToggle": { "checkedLabel": "ON", "uncheckedLabel": "OFF" }, "UITypeahead": { "noMatchesFound": "No matches found", "noOptions": "None" }, "UIWizard": { "back": "Back", "cancel": "Cancel", "done": "Done", "next": "Next", "stepCount": "Step {{stepNumber}} of {{stepCount}}" }, "XSSTooltip": { "explanation": "This link has been disabled for your security." } } } } };
  result.translationsLoaded = {
  "UIComponents": {
    "en": "static-3.1604"
  }
};
  result.translationsAvailable = {
  "UIComponents": {
    "af": "static-3.1604",
    "ar-eg": "static-3.1604",
    "bg": "static-3.1604",
    "bn": "static-3.1604",
    "ca-es": "static-3.1604",
    "cs": "static-3.1604",
    "da": "static-3.1604",
    "de": "static-3.1604",
    "el": "static-3.1604",
    "en-gb": "static-3.1604",
    "en": "static-3.1604",
    "es-mx": "static-3.1604",
    "es": "static-3.1604",
    "fi": "static-3.1604",
    "fr-ca": "static-3.1604",
    "fr": "static-3.1604",
    "he-il": "static-3.1604",
    "hr": "static-3.1604",
    "hu": "static-3.1604",
    "id": "static-3.1604",
    "it": "static-3.1604",
    "ja": "static-3.1604",
    "ko": "static-3.1604",
    "lt": "static-3.1604",
    "ms": "static-3.1604",
    "nl": "static-3.1604",
    "no": "static-3.1604",
    "pl": "static-3.1604",
    "pt-br": "static-3.1604",
    "pt-pt": "static-3.1604",
    "ro": "static-3.1604",
    "ru": "static-3.1604",
    "sk": "static-3.1604",
    "sl": "static-3.1604",
    "sv": "static-3.1604",
    "th": "static-3.1604",
    "tl": "static-3.1604",
    "tr": "static-3.1604",
    "uk": "static-3.1604",
    "vi": "static-3.1604",
    "zh-cn": "static-3.1604",
    "zh-hk": "static-3.1604",
    "zh-tw": "static-3.1604"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:UIComponents:en', {version: 'static-3.1604'}); }
})();



(function() {
  var result = { translations: { "en": { "hubPicker": { "name": "Name", "domain": "Domain", "users": "Users", "contacts": "Contacts", "products": "Products", "noFilteredResults": "Sorry, no accounts match your filter.", "hubsFailedToLoad": "There was an issue loading your account information. Please try again or select an account below.", "obscuredAccounts": { "description": "You'll be asked to log in with their identity providers if you try to access them.", "title": "Some accounts require an additional login." } }, "hubRecommend": { "title": "Your accounts", "description": "Use these accounts instead of creating a new one.", "continueButton": "Continue with this account", "showRestButton": "View your other accounts" }, "error": { "noAccounts": { "description": "You have no accounts." }, "requestFailed": { "description": "We couldn't load your accounts. Try refreshing the page." } }, "minimalHubPicker": { "hub": "Hub ID: {{portalId}}" } } } };
  result.translationsLoaded = {
  "hub-pickers-lib": {
    "en": "static-1.6716"
  }
};
  result.translationsAvailable = {
  "hub-pickers-lib": {
    "da": "static-1.6716",
    "de": "static-1.6716",
    "en": "static-1.6716",
    "es": "static-1.6716",
    "fi": "static-1.6716",
    "fr": "static-1.6716",
    "it": "static-1.6716",
    "ja": "static-1.6716",
    "nl": "static-1.6716",
    "no": "static-1.6716",
    "pl": "static-1.6716",
    "pt-br": "static-1.6716",
    "sv": "static-1.6716",
    "zh-tw": "static-1.6716"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:hub-pickers-lib:en', {version: 'static-1.6716'}); }
})();



(function() {
  var result = { translations: { "en": { "main": { "pageTitle": "Accounts Dashboard Beta | HubSpot", "header": "HubSpot Accounts", "searchText": "Search accounts", "filterText": "Compare sessions:", "filterByWeek": "Week over week", "filterByMonth": "Month over month", "filterByThirtyDay": "Last 30 days" } } } };
  result.translationsLoaded = {
  "hub-picker-ui": {
    "en": "static-1.6739"
  }
};
  result.translationsAvailable = {
  "hub-picker-ui": {
    "da": "static-1.6739",
    "de": "static-1.6739",
    "en": "static-1.6739",
    "es": "static-1.6739",
    "fi": "static-1.6739",
    "fr": "static-1.6739",
    "it": "static-1.6739",
    "ja": "static-1.6739",
    "nl": "static-1.6739",
    "no": "static-1.6739",
    "pl": "static-1.6739",
    "pt-br": "static-1.6739",
    "sv": "static-1.6739",
    "zh-tw": "static-1.6739"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:hub-picker-ui:en', {version: 'static-1.6739'}); }
})();


